import React from 'react'
import   './CustomInput.css'
function CustomInput({type,name,placeholder,handleChange,value,multiple,accept}) {
  return (
    <>
            <input
                type={type}
                name={name}
                className={"input"}
                placeholder={placeholder}
                onChange={handleChange}
                value={value}
                multiple={multiple}
                accept={accept}
              />
      
    </>
  )
}

export default CustomInput
